import { createSelector } from 'reselect';

export const fetchingEngagements = state => state.engagements.get('isFetching');

const allEngagements = state => state.engagements.get('engagements');
export const getAllEngagements = createSelector([allEngagements], engagements => engagements.toArray());
